import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../apis/AuthAPI";
import { Auth } from "../libs/utilities/helpers/Auth";
import { message } from "antd";

const OAuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoginFlow = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get("code");

      if (code) {
        try {
          const response = await dispatch(login({ attar: { code } }));
          const user = Auth.getUser();

          if (response.meta.requestStatus === "fulfilled") {
            const accessibility = user?.accessibility
              ?.filter(item => item.status)
              ?.sort((a, b) => a.index - b.index) || [];

            if (accessibility.length === 0) {
              message.error("No accessible services are available.");
              return;
            }

            navigate(`/${accessibility[0].service}`, { replace: true });
          } else {
            message.error("Login failed. Please try again.");
            navigate("/login");
          }
        } catch (err) {
          console.error("Login error:", err);
          message.error("Something went wrong during login.");
          navigate("/login");
        }
      } else {
        navigate("/login")
      }

      setLoading(false);
    };

    const isAuthenticated = Auth.isLoggedIn();
    const user = Auth.getUser();

    if (isAuthenticated) {
      const accessibility = user?.accessibility
        ?.filter(item => item.status)
        ?.sort((a, b) => a.index - b.index) || [];

      if (accessibility.length === 0) {
        message.error("No accessible services are available.");
        return;
      }

      return navigate(`/${accessibility[0].service}`, { replace: true });
    } else {
      handleLoginFlow();
    }
  }, [location.search, dispatch, navigate]);

  return null; // No UI since the login button shows loader
};

export default OAuthHandler;
